//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowResizeDiagonalRight(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.8759 6.1239L11.3705 5.55823L9.52496 7.40377L16.0233 7.97652L16.596 14.4748L18.4416 12.6293L17.8759 6.1239ZM7.40364 9.52509L5.55811 11.3706L6.12378 17.876L12.6292 18.4417L14.4747 16.5962L7.9764 16.0234L7.40364 9.52509Z" fill="currentColor" /></svg>;
}
export default IconArrowResizeDiagonalRight;